<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="520px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :showDate="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import group from "@/models/modelosDeLiquidacion/Relations/group";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.groups"),
      titleTable: "ModelosDeLiquidacion_Grupos",
      titleDelete: this.$tc("modelsLiquidations.toGroupLiquidation"),
      isLoading: true,
      nameGroup: "",
      maxWidth: ["550px", "520px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataInputs: [
        {
          name: "name",
          label: "Nombre del empleado",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.grupos ||
        modelsLiquidation.state.edit.grupos.length === 0
      ) {
        return []; // Return an empty array when grupos doesn't exist or is empty
      }

      return modelsLiquidation.state.edit.grupos.map((item) => {
        return group.fromJson(item);
      });
    },
    groups() {
      return this.$store.state.changeGroup.group.item;
    },

    employeesSelected() {
      return groups.state.groups.filter(
        (model) =>
          !modelsLiquidation.state.edit.groups.some(
            (selected) => selected.empId === model.empId
          )
      );
    },

    dataSelects() {
      return [
        {
          name: "id",
          label: "Grupo",
          data: "",
          items: this.groups,
          itemsValue: "groupId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.$store.dispatch("changeGroup/getGroups");
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    addGroup(form) {
      let payload = form;
      payload.dateStart = date.state.dateFrom;
      payload.dateEnd = date.state.dateTo;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addGroup")
        .then(() => {
          this.showAlert(
            this.$tc("modelsLiquidations.addGroupToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.errorGroup406"),
              "#ff8d58"
            );
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.errorGroup"),
              "#ff8d58"
            );
          }
          reject(error);
        });
      this.reset(false);
    },

    editGroup(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.fecDesdeOld = this.oldItems.dateStartInput;
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.id = form.id;
        payload.itemsForm = form;
        payload.nombre = this.nameGroup;

        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editGroup")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.editGroupToLiquidationSuccess"),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert("modelsLiquidations.errorGroup406", "#ff8d58");
            } else {
              this.showAlert("modelsLiquidations.errorGroup", "#ff8d58");
            }
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.dateStartInput !== newItems.dateStartInput) {
          changes.dateStartInput = newItems.dateStartInput;
        }
        if (oldItem.dateEndInput !== newItems.dateEndInput) {
          changes.dateEndInput = newItems.dateEndInput;
        }
      }

      return changes;
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          date.state.checkTo = false;
          this.dataSelects[0].readonly = false;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addGroupToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.oldItems = item;
          this.itemId = item.id;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editGroupToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      this.nameGroup = item.name;
      this.dataSelects[0].readonly = true;
      date.state.dateFrom = item.dateStartInput;
      if (item.dateEndInput !== undefined) {
        date.state.dateTo = item.dateEndInput;
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }

      this.dataSelects[0].data = item.id;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addGroup(items);
          break;
        case "edit":
          this.editGroup(items);
          break;
        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteGroup")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteGroupToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(this.$tc("modelsLiquidations.errorGroup"), "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
